import {React, useState} from 'react';
import Footer from '../Components/Footer';
import oops from "../Images/Oops.jpg";
import GalleryMount from "../Components/GalleryMount";
import Card from "../Components/Card";
import Project1 from "../Images/58-03-7th-Avenue-1.jpg";
import Project1_1 from "../Images/58-03-7th-Avenue-3.jpg";
import Project2 from "../Images/97-23-64th-Road-Rego-Park-1.jpg";
import Project2_1 from "../Images/97-23-64th-Road-Rego-Park-2.jpg";
import Project3 from "../Images/302-23rd-Street.jpg";
import Project4 from "../Images/540-6th-Ave-1.jpg";
import Project4_1 from "../Images/540-6th-Avenue-2.jpg";
import Project5 from "../Images/1999-1st-Avenue-1.jpg";
import Project5_1 from "../Images/1999-1st-Avenue-2.jpg";

const Gallery = ({display, setDisplay}) =>{
    const projects = [
        {image:Project1, description:"All architectural exterior aluminum  Windows , doors and railing.", location:"7th Avenue Brooklyn, NY", image2:Project1_1}, 
        {image:Project2, description:"All architectural aluminum store front windows, doors and railing.", location:"64th Road Rego Park, NY", image2:Project2_1}, 
        {image:Project3, description:"All architectural aluminum tilt and turn windows , store front and railing.", location:"23rd Street Brooklyn, NY"}, 
        {image:Project4, description:"All architectural aluminum windows doors and store front.", location:"6th Avenue New York, NY", image2:Project4_1}, 
        {image:Project5, description:"All architectural aluminum store front.", location:"1st Avenue New York, NY", image2:Project5_1},
    ]
    const [target, setTarget] = useState({image: oops, description:"none", location:"N/A"});
    const updateDisplay = (event) =>{

        setTarget(projects[event.currentTarget.id])
        setDisplay(true);
    }

    const projectCards = projects.map((item, i) =>{
        return <Card image={item.image} id={i} key={i} update={updateDisplay} page="gallery-card"/>
    })

    return(
        <div className="container">
            <div className="banner gallery-land">
                <h1 className="gallery-header">
                    Let Our Work Inspire Your Next Project
                </h1>
                <h2 className="gallery-header lighten">
                    (Click for details)
                </h2>
            </div>
            <section className="section gallery">
                {projectCards}
            </section>
            <GalleryMount toggle={display} target={target} set={setDisplay}/>
            <Footer/>
        </div>
    )
}

export default Gallery;
